module.exports = __webpack_public_path__ + "static/media/your-flower-art-SP.46f352ff.jpg";